import React from 'react';
import DataImporter from './index';
import { Accordion, Table } from 'react-bootstrap';
import { createArea } from '../../api/areaAPI';

const AreaImporter = ({ onComplete }) => {
  const handleDataImport = async (rows, onProgress) => {
    let count = 0;
    for (const row of rows) {
      try {
        await createArea({
          areaCode: row.areaCode,
          name: row.name,
          description: row.description,
          floc: row.floc,
          image: row.image,
          costCenterId: row.costCenterId,
          parentAreaId: row.parentAreaId,
          teamId: row.teamId,
          departmentId: row.departmentId,
          // planningGroupId: row.planningGroupId,
        });
      } catch (err) {
        console.error('Failed to import area', err);
      }
      count += 1;
      if (onProgress) onProgress(count);
    }
  };

  return (
    <>
      <div className='card h-100 p-16 rounded-0'>
        <p>
          You can bulk import <strong>areas</strong> into the system using an Excel or CSV file.
          This helps speed up onboarding or migration processes by avoiding manual
          entry.</p><p>Expand the lists below to see the required and optional fields.</p>
        <div className="mb-4">
          <Accordion alwaysOpen={false}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Required Columns</Accordion.Header>
              <Accordion.Body>
                <p>Your file must include the following column headers:</p>
                <Table bordered size="sm">
                  <thead className="table-light">
                    <tr>
                      <th>Column Name</th>
                      <th>Type</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>areaCode</td>
                      <td>Text</td>
                      <td>Unique identifier/code for the area</td>
                    </tr>
                    <tr>
                      <td>name</td>
                      <td>Text</td>
                      <td>Name or title of the area</td>
                    </tr>
                    <tr>
                      <td>departmentId</td>
                      <td>Lookup</td>
                      <td>Valid department ID from the system</td>
                    </tr>
                    <tr>
                      <td>costCenterId</td>
                      <td>Lookup</td>
                      <td>Valid cost center ID from the system</td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>Optional Columns</Accordion.Header>
              <Accordion.Body>
                <p>Your file can optionally include the following column headers:</p>
                <Table bordered size="sm">
                  <thead className="table-light">
                    <tr>
                      <th>Column Name</th>
                      <th>Type</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>description</td>
                      <td>Text</td>
                      <td>Optional text description for the area</td>
                    </tr>
                    <tr>
                      <td>floc</td>
                      <td>Text</td>
                      <td>Functional location code (if used)</td>
                    </tr>
                    <tr>
                      <td>image</td>
                      <td>Text</td>
                      <td>URL or filename of an image representing the area</td>
                    </tr>
                    <tr>
                      <td>parentAreaId</td>
                      <td>Text</td>
                      <td>ID of the parent area, if part of a hierarchy</td>
                    </tr>
                    <tr>
                      <td>teamId</td>
                      <td>Text</td>
                      <td>Associated team ID (if applicable)</td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <DataImporter
          entity="areas"
          requiredFields={[
            { 
              key: 'areaCode', 
              type: 'string', 
              required: true,
              unique: true,
            },
            { key: 'name', type: 'string', required: true },
            {
              key: 'departmentId',
              type: 'lookup',
              required: true,
              api: 'hierarchy-structures',
              nameField: 'name',
            },
            {
              key: 'costCenterId',
              type: 'lookup',
              required: true,
              api: 'cost-centres',
              nameField: 'costCenterDescription',
            },
          ]}
          onCommit={handleDataImport}
          onComplete={onComplete}
        />
      </div>
    </>
  );
};

export default AreaImporter;
